<template>
  <div>
    <div v-loading="loading"
         id="select-point-map-container"></div>
    <!-- 地图搜索位置 -->
    <span>
      <el-cascader v-model="selectDest"
                   style="width:30%"
                   size="mini"
                   :options="option"
                   @change="handleChange"
                   :props="dataProps"
                   placeholder="请选择">
      </el-cascader>

      <el-autocomplete v-model="key_word"
                       :trigger-on-focus="false"
                       value-key="title"
                       :fetch-suggestions="querySearchAsync"
                       placeholder="请输入地点名称"
                       class="input-with-select"
                       style="width:70%"
                       size="mini"
                       @select="handleSelectPoi">
        <el-button slot="append"
                   @click="searchKeyWordOnMap"
                   icon="el-icon-search"></el-button>
      </el-autocomplete>
    </span>
    <!-- 位置信息 -->
    <div v-if="showLatlng"
         class="show-location-latlng">
      地图源：腾讯地图 纬度lat：{{ lat }} 经度lng：{{ lng }}

      <el-dropdown style="text-align: right"
                   size="mini"
                   split-button
                   @click="confirmPoi()">
        确定位置
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>腾讯地图</el-dropdown-item>
          <el-dropdown-item>谷歌地图</el-dropdown-item>
          <el-dropdown-item>高德地图</el-dropdown-item>
          <el-dropdown-item>百度地图</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
let marker = null
export default {
  name: 'point-on-map',
  data() {
    return {
      loading: true,
      map: {},
      map_source: 'qq',
      lng: 109.5142936706543,
      lat: 18.243943345260536,
      data: '',
      option: [], // 目的地列表
      selectDest: '', //选择搜索的目的地
      key_word: '', // 搜索关键词
      dataProps: {
        emitPath: false, // 返回数组还是返回单个id
        label: 'loc_name',
        value: 'loc_id',
        children: 'children',
      },
    }
  },
  props: {
    showLatlng: {
      type: Boolean,
      default: true,
    },
    proplat: {
      type: Number,
      default: 109.5142936706543,
    },
    proplng: {
      type: Number,
      default: 18.243943345260536,
    },
  },
  mounted() {
    this.onLoadMap()
    this.loadDest()
  },
  methods: {
    onLoadMap() {
      this.loading = true
      // 获取地图容器
      let mapContainer = document.getElementById('select-point-map-container')
      // 配置地图选项 ----- https://lbs.qq.com/webApi/javascriptGL/glDoc/docIndexMap#2
      let that = this
      let options = {
        // TMap.LatLng(）创建经纬度坐标实例
        center: new TMap.LatLng(that.lat, that.lng),
        zoom: 13,
        mapStyleId: 'style1',
      }
      // 创建地图 地图初始化 ---
      this.map = new TMap.Map(mapContainer, options)
      // 去掉比例尺
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.SCALE)
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION)

      this.loading = false
      // 标记地图-------
      // 监听点击事件
      this.map.on('click', function (event) {
        if (!marker) {
          // 如果没有 点标记，那么创建一个点标记的类
          marker = new TMap.MultiMarker({
            map: that.map,
          })
        } else if (marker) {
          // 如果有 点标记，那么需要先移除原来的点标记
          marker.setMap(null)
          marker = null
          // 再重新创建点标记
          marker = new TMap.MultiMarker({
            map: that.map,
          })
        }
        //  将点击事件获得的 数据 付给经纬度
        marker.add({ position: event.latLng })
        that.lng = event.latLng.getLng()
        that.lat = event.latLng.getLat()
      })
    },
    showPoiMarker(lat, lng) {
      if (marker) {
        // 清除点标记
        marker.setMap(null)
        marker = null
      }
      // 创建点标记实例
      marker = new TMap.MultiMarker({
        map: this.map,
      })
      // 添加 点标记
      let newLatLng = new TMap.LatLng(lat, lng)
      marker.add({ position: newLatLng })
      // 设置中心
      this.map.setCenter(newLatLng)
    },
    confirmPoi() {
      this.$emit('getLatLng', this.lat, this.lng, this.map_source)
    },
    // 获取所有目的地
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        if (res.data.errno == '0') {
          this.option = res.data.data
        } else {
          this.$message({
            message: res.data.errmsg,
            type: 'error',
          })
        }
      })
    },
    // 选择目的地
    handleChange() {
      console.log(this.selectDest)
    },
    // 搜索 qq地图服务端
    searchKeyWordOnMap() {},
    // 自动检索
    querySearchAsync(queryString, callback) {
      // console.log('发送请求')
      // console.log(queryString)
      let back_data_list
      this.$http
        .get(
          `/traver/get_map_qq_key_word_suggestion?key_word=${queryString}&dest=${this.selectDest}`
        )
        .then((res) => {
          // 请求结果
          if (res.data.errno == '0') {
            back_data_list = res.data.data
            // 是否有键入
            // console.log(this.createStateFilter(queryString))
            let results = queryString
              ? back_data_list.filter(this.createStateFilter(queryString))
              : back_data_list

            // 返回数据
            callback(results)
          } else {
            // console.log(res.data.errmsg)
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 过滤器
    createStateFilter(queryString) {
      // 返回一个函数
      return (state) => {
        // console.log(state.title.toLowerCase())

        return (
          state.title.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    // 选择搜索结果的一项
    handleSelectPoi(val) {
      // console.log(val)
      // 执行定位
      this.showPoiMarker(val.location.lat, val.location.lng)

      let item = {
        lat: val.location.lat,
        lng: val.location.lng,
        title: val.title,
        dest: this.selectDest,
        map_source: this.map_source,
      }
      ;(this.lat = val.location.lat),
        (this.lng = val.location.lng),
        this.$emit('selectSuggestion', item)
    },
  },
}
</script>

<style>
#select-point-map-container {
  height: 300px;
  width: 100%;
  border-radius: 5px;
}
.show-location-latlng {
  font-size: 12px;
  background-color: bisque;
  padding: 10px;
  height: 30px;
  width: auto;
  text-align: left;
}
.search-poi-on-map {
}
</style>